var assign = require('object-assign');
var USER_KEY = 'cargomatic-admin-user';
var PREFERENCES_KEY = 'cargomatic-admin-user-preferences';
import SessionStore from 'stores/SessionStore';
let userColKey;
var setMarketsPreference = function (markets) {
    var preferences = JSON.parse(localStorage.getItem(PREFERENCES_KEY)) || {};
    preferences.markets = markets;
    localStorage.setItem(PREFERENCES_KEY, JSON.stringify(preferences));
};
var getMarketsPreference = function () {
    var preferences = JSON.parse(localStorage.getItem(PREFERENCES_KEY)) || {};
    return preferences.markets || [];
};
var setShipmentListColIsHidden = function (headerNames) {
    if (SessionStore.getUser() != null) {
        userColKey = SessionStore.getUser().email;
    }
    var usercol = JSON.parse(localStorage.getItem(userColKey)) || {};
    usercol.headerNames = headerNames;
    localStorage.setItem(userColKey, JSON.stringify(usercol));
};
var getShipmentListColIsHidden = function () {
    if (SessionStore.getUser() != null) {
        userColKey = SessionStore.getUser().email;
    }
    var usercol = JSON.parse(localStorage.getItem(userColKey)) || {};
    return usercol.headerNames || [];
};
export default {
    setMarketsPreference: setMarketsPreference,
    getMarketsPreference: getMarketsPreference,
    setShipmentListColIsHidden: setShipmentListColIsHidden,
    getShipmentListColIsHidden: getShipmentListColIsHidden,
};
